import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import RecipientNameSchema from "notifications/recipients/recipient-name-schema";

export default class RecipientName {
  public static fromJSON(value: unknown): RecipientName | null | undefined {
    if (isNullOrUndefined(value)) return value;
    const parsed = RecipientNameSchema.deserialize(value);
    return new RecipientName(parsed);
  }

  public get value(): string {
    return this._value;
  }

  public constructor(value: string) {
    this._value = value;
  }

  public toJSON(): string {
    return this.value;
  }

  public clone(): RecipientName {
    return new RecipientName(this.value);
  }

  public isEqualTo(other: RecipientName): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value;
  }

  private readonly _value: string;
}
